'use client';

import React, { useState } from 'react';
import InboxSidebar from './InboxSidebar';
import MessageList from './MessageList';
import MessageReader from './MessageReader';
import InboxTopbar from './InboxTopbar';
import { mockMessages } from '../data/mockMessages';
import type { Message } from '../data/mockMessages';
import { InboxThemeProvider, useInboxTheme } from '@/contexts/InboxThemeContext';

function InboxContent() {
  const [selectedMessage, setSelectedMessage] = useState<Message | null>(mockMessages[0]);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeFolder, setActiveFolder] = useState<'inbox' | 'starred' | 'trash'>('inbox');
  const { theme } = useInboxTheme();

  const filteredMessages = mockMessages.filter((m) => {
    if (activeFolder === 'starred') return m.starred;
    if (activeFolder === 'trash') return m.trashed;
    return !m.trashed;
  });

  return (
    <div className={`flex h-screen overflow-hidden inbox-bg inbox-theme-${theme}`}>
      {/* Ambient glow orbs */}
      <div className="inbox-glow-orb-1" />
      <div className="inbox-glow-orb-2" />
      <div className="inbox-glow-orb-3" />

      {/* Sidebar */}
      <InboxSidebar
        open={sidebarOpen}
        activeFolder={activeFolder}
        onFolderChange={setActiveFolder}
      />

      {/* Main content */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden relative z-10">
        <InboxTopbar onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />

        <div className="flex flex-1 min-h-0 overflow-hidden">
          {/* Message list */}
          <MessageList
            messages={filteredMessages}
            selectedId={selectedMessage?.id ?? null}
            onSelect={setSelectedMessage}
            folder={activeFolder}
          />

          {/* Message reader */}
          <MessageReader message={selectedMessage} />
        </div>
      </div>
    </div>
  );
}

export default function InboxLayout() {
  return (
    <InboxThemeProvider>
      <InboxContent />
    </InboxThemeProvider>
  );
}